import { AbstractCollection } from '../../abstract/Collection';
import { AbstractDocument, Identifiable, Timestampable, Untrackable } from '../../abstract/Document';
import { type Supplier, Suppliers } from '../Suppliers';
import type { IReport } from './Reports.types';

@Identifiable
@Timestampable
@Untrackable
export class Report extends AbstractDocument<IReport> {
  readonly collections = {};
}

export class Reports extends AbstractCollection<Report, IReport> {
  static path = 'reports';

  constructor(document: Supplier) {
    super(document.collection(Reports.path), Report);
  }

  get supplier() {
    return Suppliers._.getById(this.reference.parent!.id);
  }
}
